








































import Vue, { PropOptions } from 'vue';
import type { FrameworkItem } from '@/components/storyblok/FrameworkItem.vue';
import type { PaddingOptions } from '@/components/SectionContainer.vue';

export type FrameworksBar = Blok & {
  title: string;
  frameworks: FrameworkItem[];
  showTitle: boolean;
  showFrameworkLabels: boolean;
  animation: boolean;
  paddingTop?: PaddingOptions;
  paddingBottom?: PaddingOptions;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<FrameworksBar>,
  },
});
